import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../state/authStore.ts';
import { authApi } from '../api/auth.ts';

export default function NavBar() {
  const user = useAuthStore(s => s.user);
  const setUser = useAuthStore(s => s.setUser);
  const navigate = useNavigate();
  const location = useLocation();

  const onSignOut = async () => {
    await authApi.signOut();
    setUser(null);
    navigate('/');
  };

  const isCurrent = (path: string) =>
    location.pathname === path ? ('page' as const) : undefined;

  return (
    <header className="navbar" role="banner">
      <Link to="/" className="brand" aria-label="EAA Proof — home" aria-current={isCurrent('/')}>
        <span className="brand-mark" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" focusable="false">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </span>
        EAA Proof
      </Link>
      <nav className="nav-links" aria-label="Primary">
        <Link to="/sample" aria-current={isCurrent('/sample')}>Sample report</Link>
        <Link to="/pricing" aria-current={isCurrent('/pricing')}>Pricing</Link>
        {user ? (
          <>
            <span className="credits" aria-label={`${user.creditBalance} credits remaining`}>
              {user.creditBalance} credits
            </span>
            <Link to="/profile" className="user-name" aria-current={isCurrent('/profile')}>
              {user.displayName ?? user.email}
            </Link>
            <button type="button" className="link-button" onClick={onSignOut}>Sign out</button>
          </>
        ) : (
          <Link to="/sign-in" className="cta-link" aria-current={isCurrent('/sign-in')}>Sign in</Link>
        )}
      </nav>
    </header>
  );
}
